import RestX from 'highered-utils/restx';
import { ResourceNode } from './types/resources';
import SchoolService from '~/services/SchoolService';

class ResourceService {
    static async getRootFolders(): Promise<{ data: ResourceNode[] }> {
        const root = 'root';
        const schoolId = SchoolService.getCurrentSchoolId();

        return (
            ((RestX.getInterfaces() as any).resources.folder.id(root).get({
                organization: schoolId,
            }) as { data: ResourceNode[] }) || []
        );
    }

    static async getFolderById(folderId: String): Promise<{ data: ResourceNode[] }> {
        const schoolId = SchoolService.getCurrentSchoolId();

        return (
            ((RestX.getInterfaces() as any).resources.folder.id(folderId).get({
                organization: schoolId,
            }) as { data: ResourceNode[] }) || []
        );
    }

    static async getFileById(folderId: string): Promise<{ data: ResourceNode }> {
        return (RestX.getInterfaces() as any).resources.nodes.id(folderId).get() as {
            data: ResourceNode;
        };
    }
}

export const HIGHERED_CV_TEMPLATE =
    'https://content.gethighered.global/miscellaneous/Highered_CV_Template.docx';

export default ResourceService;
